<template>
	<div class="container">
		<div class="content">
			<div class="qrcode-wrap">
				<img  class="qrcode" :src="`${themePicUrl}zq_pro/zhekou/product/${productType}.jpg`" alt="">
				<span class="tips_first">购卡成功</span>
				<span class="tips_sceond">长按识别二维码进入小程序去激活使用吧</span>
				<a class="button" :href="`${themePicUrl}zq_pro/zhekou/product/${productType}.jpg`" download="zqwlqrcode">保存二维码</a>
			</div>
		</div>
	</div>
</template>

<script>
import request from '../utils/request.js'
import Cookies from "js-cookie"

export default {
	name: 'Qrcode',
	components: {},
	data() {
		return {
			themePicUrl: '',
			productType: ''
		}
	},
	created() {
		this.getProductType()
		this.picUrlQuery()
	},
	methods: {
		// 圖片前綴
		picUrlQuery() {
			const that = this
			request({
				url: '/tour-product/imge/getUrl',
				method: 'post'
			})
			.then(function (res) {
				if(res.data.code != '200'){
					throw res.data.msg
				}
				if(res.data.code == '200'){
					that.themePicUrl = res.data.data;
					console.log(that.themePicUrl);
				}
			})
			.catch(function (err) {
				console.log(err);
			});
		},
		getProductType() {
			const productTypes = ["0", "5", "8"]
			this.productType = productTypes.includes(Cookies.get("productType")) ? Cookies.get("productType") : 0
		}
	}
}
</script>

<style scoped>
	html,body,#app{
		height: 100%;
		margin: 0;
	}
	.h100 {
		height: 100px;
	}
	.container {
		display: flex;
		flex-direction: column;
		height: 100%;
		background-color: #FFF;
	}
	.header {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100px;
	}
	.content {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		position: fixed;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0px;
		width: 100%;
		overflow-x:hidden;
		overflow-y: scroll;
	}
	.qrcode-wrap {
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	.qrcode {
		display: block;
		margin: 0 auto;
		width: 260px;
		/* height: 248px; */
	}
	
	.tips_first {
		padding: 46px 0 29px 0;
		font-size: 45px;
		font-weight: bold;
	}
	.tips_sceond {
		font-size: 28px;
		color: #999;
		padding-bottom: 104px;
	}
	.button {
		border-radius: 44px;
		width: 330px;
		height: 88px;
		font-size: 32px;
		font-weight: bold;
		line-height: 88px;
		text-align: center;
		color: #FFF;
		background: #00BE59;
	}
</style>
